import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";

const RelatedArticles = ({ categorySlug, previousSlug }) => {
  const [articles, setArticles] = useState([]);
  const navigate = useNavigate();
  const location = useLocation(); // Listen for changes on every navigation

  // Fetch articles with optional category filter
  const fetchArticles = useCallback(async () => {
    try {
      let url =
        "https://blognxa.wpcomstaging.com/wp-json/wp/v2/posts?per_page=100&_embed";
      if (categorySlug) {
        url += `&categories_slug=${categorySlug}`; // Ensure your WP REST API supports this param
      }
      const response = await axios.get(url);
      const shuffled = response.data.sort(() => 0.5 - Math.random());
      setArticles(shuffled.slice(0, 3));
    } catch (error) {
      console.error("Error fetching related articles:", error);
    }
  }, [categorySlug]);

  // Re-fetch when location changes (navigation)
  useEffect(() => {
    fetchArticles();
  }, [fetchArticles, location.key]);

  // Format date to readable format
  const formatDate = (dateStr) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateStr).toLocaleDateString(undefined, options);
  };

  // Decode HTML entities in titles, categories
  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  // Navigate to blog details page with categorySlug and previousSlug
  const handleClick = (slug) => {
    navigate(`/blog-details/${slug}`, {
      state: { categorySlug, previousSlug },
    });
    // OR to use query parameters instead of state:
    // navigate(`/blog-details/${slug}?category=${categorySlug}&prev=${previousSlug}`);
  };

  return (
    <>
      <div className="related-article-head">
        Related <span>Post</span>
      </div>
      <section className="related-articles">
        {articles.map((article) => (
          <div className="related-articles__card" key={article.id}>
            <img
              className="related-articles__image"
              src={
                article._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                "../assets/images/product_dropdown/sa.svg"
              }
              alt={decodeHtml(article.title.rendered)}
            />
            <div className="related-articles__info">
              <span className="related-articles__category">
                {decodeHtml(
                  article._embedded?.["wp:term"]?.[0]?.[0]?.name || "General"
                )}
              </span>
              <span className="related-articles__date">
                {formatDate(article.date)}
              </span>
            </div>
            <h3
              className="related-articles__title"
              dangerouslySetInnerHTML={{ __html: article.title.rendered }}
            />
            <button
              onClick={() => handleClick(article.slug)}
              className="related-articles__button"
            >
              Read More
            </button>
          </div>
        ))}
      </section>
    </>
  );
};

export default RelatedArticles;
